import React from "react";
import cpLoading from "../assets/cp-loading.json";
import Lottie from "react-lottie-player";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  position: fixed;
  z-index: 99;
  background-color: rgba(255, 255, 255, 0.87);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
`;

const Loading = () => {
  return (
    <Container>
      <Wrapper>
        <Lottie
          play
          loop
          animationData={cpLoading}
          style={{ width: 400, height: 400 }}
        ></Lottie>
      </Wrapper>
    </Container>
  );
};

export default Loading;
